module.exports = __webpack_public_path__ + "static/media/perks1.7b57395b.png";